import { USERS_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        checkUserExists: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/checkuser`,
                method: 'POST',
                body: data,
            }),
        }),
        register: builder.mutation({
            query: (body) => ({
                url: USERS_URL,
                method: 'POST',
                body,
                credentials: 'include'
            })
        }),
        login: builder.mutation({
            query: (token) => ({
                url: `${USERS_URL}/auth`,
                method: 'POST',
                body: {token},
                credentials: 'include'
            })
        }),
        logout: builder.mutation({
            query: () => ({
                url: `${USERS_URL}/logout`,
                method: 'POST',
            })
        }),
        profile: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/profile`,
                method: 'PUT',
                body: data
            })
        }),
        getUsers: builder.query({
            query: () => ({
                url: USERS_URL
            }),
            providesTags: ['Users'],
            keepUnusedDataFor: 5
        }),
        getUser: builder.query({
            query: (userId) => ({
                url: `${USERS_URL}/${userId}`
            })
        }),
        updateUser: builder.mutation({
            query: (userData) => ({
                url: `${USERS_URL}/${userData._id}`,
                method: "PUT",
                body: userData
            }),
            invalidatesTags: ['Users']
        }),
        deleteUser: builder.mutation({
            query: (userId) => ({
                url: `${USERS_URL}/${userId}`,
                method: "DELETE"
            })
        }),
        checkDeliveryPartnerExists: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/checkdeliverypartner`,
                method: 'POST',
                body: data,
            }),
        }),
        registerDeliveryPartner: builder.mutation({
            query: (body) => ({
                url: `${USERS_URL}/deliverypartner/register`,
                method: 'POST',
                body,
                credentials: 'include'
            })
        }),
        loginDeliveryPartner: builder.mutation({
            query: (token) => ({
                url: `${USERS_URL}/deliverypartner/login`,
                method: 'POST',
                body: {token},
                credentials: 'include'
            })
        }),
        getDeliveryPartners: builder.query({
            query: (status = "all") => ({
                url: `${USERS_URL}/deliverypartner?status=${status}`
            }),
            providesTags: ['Users'],
            keepUnusedDataFor: 5
        }),
        approveDeliveryPartner: builder.mutation({
            query: ({ id, approval }) => ({
                url: `${USERS_URL}/deliverypartner/${id}/approval`,
                method: "PUT",
                body: { approval }
            }),
            invalidatesTags: ['Users'],
        }),
        getDeliveryPartnerDocuments: builder.query({
            query: () => ({
                url: `${USERS_URL}/deliverypartner/documents`
            }),
            providesTags: ['Users'],
            keepUnusedDataFor: 5
        }),
        getSourcingPartners: builder.query({
            query: (status = "all") => ({
                url: `${USERS_URL}/sourcingpartner?status=${status}`
            }),
            providesTags: ['Users'],
            keepUnusedDataFor: 5
        })
    })
})

export const {
    useCheckUserExistsMutation,
    useLoginMutation,
    useLogoutMutation,
    useRegisterMutation,
    useProfileMutation,
    useGetUsersQuery,
    useGetUserQuery,
    useUpdateUserMutation,
    useDeleteUserMutation,
    useCheckDeliveryPartnerExistsMutation,
    useLoginDeliveryPartnerMutation,
    useRegisterDeliveryPartnerMutation,
    useGetDeliveryPartnersQuery,
    useApproveDeliveryPartnerMutation,
    useGetDeliveryPartnerDocumentsQuery,
    useGetSourcingPartnersQuery
} = usersApiSlice;